import React from 'react';
import { StaggerContainer, StaggerItem } from '../ui/AnimatedSection';
import { useTenant } from '../../context/TenantContext';
import { inlineEm } from './inlineEm';
import { MarketingSectionHeader } from './SectionHeader';

const DEFAULT_HEADING = 'What you *leave* with';
const DEFAULT_SUBHEAD =
  'Each programme is built around a small number of skills you will be measurably better at by the end.';

export const Outcomes: React.FC = () => {
  const { tenant } = useTenant();
  const marketing = tenant?.branding.marketing;
  const outcomes = (marketing?.outcomes ?? []).filter(o => o.title?.trim());

  if (outcomes.length === 0) return null;

  return (
    <section id="outcomes" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <MarketingSectionHeader
          marker="§ Outcomes"
          rubric="What you leave with"
          headline={marketing?.copy?.outcomesHeading?.trim() || DEFAULT_HEADING}
          subhead={marketing?.copy?.outcomesSubhead?.trim() || DEFAULT_SUBHEAD}
        />

        <StaggerContainer className="grid md:grid-cols-2 border-t border-gray-900">
          {outcomes.map((outcome, i) => (
            <StaggerItem key={i}>
              <div
                className={`grid grid-cols-[56px_1fr] gap-6 py-9 transition-colors hover:bg-gray-50/60 border-b border-gray-200 ${
                  i % 2 === 0 ? 'md:pr-10 md:border-r md:border-gray-200' : 'md:pl-8'
                }`}
              >
                <div className="font-mono text-xs uppercase tracking-wider text-primary-600 pt-2">
                  → {String(i + 1).padStart(2, '0')}
                </div>
                <div>
                  <h3 className="font-serif text-xl md:text-2xl text-gray-900 leading-tight tracking-tight mb-3">
                    {inlineEm(outcome.title)}
                  </h3>
                  {outcome.body && (
                    <p className="text-gray-600 leading-relaxed">{outcome.body}</p>
                  )}
                </div>
              </div>
            </StaggerItem>
          ))}
        </StaggerContainer>
      </div>
    </section>
  );
};
